import React from 'react';

export default function Loading() {
  return (
    <span className="flex h-8 w-8">
      <span className="animate-ping absolute inline-flex h-6 w-6 rounded-full bg-primary-400 opacity-25"></span>
      <span className="relative inline-flex rounded-full h-6 w-6 bg-primary-400"></span>
    </span>
  );
}
